import Vue from "vue";
import VueModal from "../components/cards/VueModal.vue";

const ModalPlugin = {
  install(Vue) {
    // Register component globally
    Vue.component("global-modal", VueModal);

    // Add modal methods to Vue prototype
    Vue.prototype.$modal = {
      show(component, props = {}, on = {}) {
        return new Promise((resolve) => {
          const ModalComponent = Vue.extend({
            render(h) {
              return h(
                VueModal,
                {
                  props: {
                    visible: true,
                    ...props,
                  },
                  on: {
                    close: () => {
                      this.visible = false;
                      setTimeout(() => {
                        this.$destroy();
                        this.$el.remove();
                      }, 300);
                    },
                    ...on,
                  },
                },
                [
                  h(component, {
                    on: {
                      close: (data) => {
                        resolve(data);
                        this.visible = false;
                        setTimeout(() => {
                          this.$destroy();
                          this.$el.remove();
                        }, 300);
                      },
                    },
                  }),
                ]
              );
            },
            data() {
              return {
                visible: true,
              };
            },
          });

          const modal = new ModalComponent().$mount();
          document.body.appendChild(modal.$el);
        });
      },
    };
  },
};

export default ModalPlugin; // Add this export
